import utils from './utils.js'
import { Assets } from './metadata.js'
import Contract from 'web3-eth-contract'
import Web3 from 'web3'
import erc201 from '../abi/exs.json'
import onion1 from '../abi/onionAuction.json'
import onionAuctionPoly from '../abi/onionAuctionpoly.json'
import erc20poly from '../abi/exspoly.json'
import erc20binance from '../abi/USDT_BINANCE.json'
import onionAuctionBinance from '../abi/onionAuction_FirstMarket.json'

const currentNetwork = localStorage.getItem("currentNetwork") || "MUMBAI"

var onion = null
var erc20 = null
var environement = `${process.env.REACT_APP_ENVIRONMENT}`
if (currentNetwork == "MUMBAI" && environement == "live" || currentNetwork == "MUMBAI" && environement == "staging") {

    onion = onionAuctionPoly
    erc20 = erc20poly
}
else {
    onion = currentNetwork == "BINANCE" && environement == "live" ? onionAuctionBinance : onion1
    erc20 = erc20 = currentNetwork == "BINANCE" && environement == "live" ? erc20binance : erc201
}


const ERC20 = {
    contract(Provider, addressContract, abi) {
        const provider = localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? `${process.env.REACT_APP_MUMBAI_RPC}` : `${process.env.REACT_APP_BINANCE_RPC}` : `${process.env.REACT_APP_MUMBAI_RPC}`
        const web3 = new Web3(provider)
        const contract = new web3.eth.Contract(abi, addressContract)
        return contract
    },
    toDecimals(value, decimals) {
        const decimal = Math.pow(10, decimals)
        const balance = Number.parseFloat(value / decimal).toFixed(16) //please do not move this, as it maintains floating point precision.
        return balance
    },
    async providerRPC(Provider, tokenAddress) {
        try {
            const contract = this.contract(Provider, tokenAddress, erc20["abi"])
            return contract
        } catch (error) {
            console.log(error)
        }

    },
    explorerTx(chain, tx) {
        const url = Assets[chain].explorers[0]
        let urlTx = url + '/tx/' + tx
        return urlTx
    },
    notifyERC20Sent(eventTransfer, dispatch) {
        let data = {
            type: "exsSent",
            to: eventTransfer.to,
            amount: utils.fromWei(eventTransfer.value),
            tx: eventTransfer.tx
        }
        dispatch('notificationSystem/addNotify', data, { root: true })
    },
    fromDecimals(x, token) {
        if (token.decimals == 18) {
            return utils.toWei(x)
        }
        const xInt = Math.pow(10, token.decimals)
        const xWei = x * xInt
        return xWei
    },
    subAmount(x, yWei, token) {
        /**
         * integer operations, the standard Web3 library is not used as 
         * some ERC20s use a different decimal system.
         */
        if (token.decimals == 18) {
            const xWei = utils.toWei(x) // transform x to xWei (WEI is name of uint256 in ETH 10**18 = 1.<18decimals>...)
            const xBn = utils.toBn(xWei) // transform x to BigNumber
            const yBn = utils.toBn(yWei) // transfor y to BigNumber
            const newAmount = xBn.sub(yBn) // sub yWei from xWei of two BigNumbers
            return this.toDecimals(newAmount, token.decimals) // transform BigNumbers to decimals
        } else {
            const xInt = Math.pow(10, token.decimals)
            const xWei = x * xInt
            const xBn = utils.toBn(xWei)
            const yBn = utils.toBn(yWei)
            const newAmount = xBn.sub(yBn)
            return this.toDecimals(newAmount, token.decimals)
        }
    },

    addAmount(x, yWei, token) {
        /**
         * integer operations, the standard Web3 library is not used as 
         * some ERC20s use a different decimal system.
         */
        if (token.decimals == 18) {
            const xWei = utils.toWei(x) // trnasform x to xWei
            const xBn = utils.toBn(xWei) // transform x to BigNumber
            const yBn = utils.toBn(yWei) // transfor y to BigNumber
            const newAmount = xBn.add(yBn) // sum of two BigNumbers
            return this.toDecimals(newAmount, token.decimals) //transforms BigNumbers to Decimals
        } else {
            const xInt = Math.pow(10, token.decimals)
            const xWei = x * xInt
            const xBn = utils.toBn(xWei)
            const yBn = utils.toBn(yWei)
            const newAmount = xBn.add(yBn)
            return this.toDecimals(newAmount, token.decimals)
        }
    },

    proccesERC20EventTransfer(event, token, web3, address, balances) {
        const amount = web3.eth.abi.decodeParameter('uint256', event.data)
        const from = web3.eth.abi.decodeParameter('address', event.topics[1])
        const to = web3.eth.abi.decodeParameter('address', event.topics[2])
        const actualBalance = balances[token.name]
        var newAmount
        if (utils.isSameAddress(from, address)) {
            newAmount = this.subAmount(actualBalance, amount, token) //sent
        } else {
            newAmount = this.addAmount(actualBalance, amount, token) //received
        }
        const data = {
            from: from,
            to: to,
            type: utils.isSameAddress(from, address) ? 'sent' : 'received',
            amount: this.toDecimals(amount, token.decimals), //transform wei to decimals token
            name: token.name,
            symbol: token.symbol,
            newAmount: newAmount,
            tx: event.transactionHash
        }
        return data
    },

    async mainBalance(Provider, address) {
        try {
            var web3 = new Web3(Provider.provider)
            var balance = await web3.eth.getBalance(address)
            return Web3.utils.fromWei(balance)
        } catch (error) {
            console.log(error)
        }

    },
    async transfer(Provider, from, Transfer, token, dispatch, popup) {
        await dispatch('notificationSystem/add', popup, { root: true })
        const contract = await this.providerRPC(Provider, token.address)
        const amount = this.fromDecimals(Transfer.amount, token)
        const gas = await contract.methods.transfer(Transfer.to, amount).estimateGas({ from: from })
        await contract.methods.transfer(Transfer.to, amount).send({
            from: from,
            gas: gas * 2
        }).on('transactionHash', async function (hash) {
            var update = {
                type: "transferERC20",
                key: "hash",
                value: hash
            }
            await dispatch('notificationSystem/update', update, { root: true })
            return true
        })
    },
    proccesContractEvent(event, tokens, web3, address, balances) {
        const addressContract = event.address
        const token = tokens.find(x => x.address === addressContract)
        var data
        switch (token.name) {
            default: return null
            case 'Ex-Sports':
                data = token
                break
            case 'EXS':
                data = this.proccesERC20EventTransfer(event, token, web3, address, balances)
                break
            case 'USDT':
                data = this.proccesERC20EventTransfer(event, token, web3, address, balances)
                break
        }
        return data
    },
    async balance(Provider, address, token) {
        console.log(Provider)
        console.log(address)
        console.log(token)
        try {

            const contract = await this.providerRPC(Provider, token.address)
            const balance = await contract.methods.balanceOf(address).call()
            const balanceFixed = this.toDecimals(balance, token.decimals)
            console.log(balanceFixed)
            return balanceFixed
        } catch (error) {
            console.log(error)
        }
    },
    async balanceforWalletConnect(address, token) {
        console.log(address)
        console.log(token)
        try {
            const provider = localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? `${process.env.REACT_APP_MUMBAI_RPC}` : `${process.env.REACT_APP_BINANCE_RPC}` : `${process.env.REACT_APP_MUMBAI_RPC}`
            console.log(provider)
            const web3 = new Web3(provider)
            // const adress = localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? `${process.env.REACT_APP_MUMBAI_ER20}` : `${process.env.REACT_APP_BINANCE_ER20}` : `${process.env.REACT_APP_MUMBAI_ER20}`
            const adress = token?.address
            console.log(adress)
            var contractAddress = adress
            var onionAdress = `${process.env.REACT_APP_RINKEY_ONION}`
            var contract = new web3.eth.Contract(erc20['abi'], contractAddress);
            console.log(contract)
            const balance = await contract.methods.balanceOf(address).call()
            console.log(balance)
            const balanceFixed = this.toDecimals(balance, token.decimals)
            console.log(balanceFixed)
            return balanceFixed
        } catch (error) {
            console.log(error)
        }
    },
    async balanceforEtherWALLET(address, token) {
        try {
            const web3 = new Web3(`${process.env.REACT_APP_RINKEY_RPC}`)
            var contractAddress = `0xDD5CBBfb58B1463611433b12d256DC30AE24BF42`
            var onionAdress = `${process.env.REACT_APP_RINKEY_ONION}`
            var contract = new web3.eth.Contract(erc20['abi'], contractAddress);
            console.log(contract)
            const balance = await contract.methods.balanceOf(address).call()
            const balanceFixed = this.toDecimals(balance, token.decimals)
            console.log(balanceFixed)
            return balanceFixed
        } catch (error) {
            console.log(error)
        }
    },
    async listenTransferErc20(Provider, address, commit, balances, dispatch, tokens) {
        try {
            const contractAddresses = []
            tokens.forEach(token => {
                contractAddresses.push(token.address)
            });
            let options = {
                address: contractAddresses,
                topics: [
                    ["0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef", //hash transfer ERC20
                        address, //From
                        null
                    ],
                    ["0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
                        null,
                        address, //To
                    ]
                ]
            }
            const web3 = new Web3(Provider.sockets[0])
            web3.eth.subscribe('logs', options, (err, events) => {
                if (events.topics[0] == "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef") {
                    const data = this.proccesContractEvent(events, tokens, web3, address, balances)
                    const tokenName = data.symbol
                    const balance = data.newAmount
                    data.tx = `${Provider.explorer}/tx/${data.tx}`
                    commit('updateBalance', { tokenName, balance })
                    dispatch('notificationSystem/addNotify', data, { root: true })
                    dispatch("Transactions/receiverEventTransferERC20", data, { root: true })
                }
            })
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }
}

export default ERC20